var _defs, _path, _rect, _rect2, _polygon, _path2, _rect3, _line, _line2, _rect4, _path3, _polygon2, _polygon3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTutorial(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Category Tutorial") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#6de2e2;}.cls-1,.cls-5,.cls-6{stroke:#282d3d;stroke-miterlimit:10;stroke-width:3px;}.cls-2{fill:#c4c5ca;}.cls-3{fill:#282d3d;}.cls-4,.cls-6{fill:#fff;}.cls-5{fill:none;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.49,80.5a16.93,16.93,0,0,1,7.33-14.41c12.88-8.56,21-17.44,20.67-32.87,0-8.15-3.8-16-10.54-21.72a36.73,36.73,0,0,0-24.46-9h-3A36.73,36.73,0,0,0,24,11.5C17.3,17.26,13.5,25.07,13.5,33.22c-.34,15.43,7.79,24.31,20.67,32.87A16.93,16.93,0,0,1,41.5,80.5Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 42,
    y: 96,
    width: 16,
    height: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 23,
    y: 29,
    width: 54,
    height: 3
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "66.5 42.17 49.5 48 33.5 42.17 33.5 30.5 66.5 30.5 66.5 42.17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M49.48,49.59,32,43.22V29H68V43.24ZM35,41.12l14.52,5.29L65,41.1V32H35Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 38,
    y: 29,
    width: 3,
    height: 27
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 40,
    y1: 87.5,
    x2: 54,
    y2: 87.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 41,
    y1: 80.5,
    x2: 59,
    y2: 80.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 48,
    y: 96,
    width: 4,
    height: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M41.5,80.5h17a0,0,0,0,1,0,0V91.78a2.72,2.72,0,0,1-2.72,2.72H44.22a2.72,2.72,0,0,1-2.72-2.72V80.5A0,0,0,0,1,41.5,80.5Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "49.59 55.86 51.73 59.78 55.66 61.93 51.73 64.08 49.59 68 47.44 64.08 43.52 61.93 47.44 59.78 49.59 55.86"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "59.59 10.83 61.85 14.97 66 17.24 61.85 19.51 59.59 23.66 57.32 19.51 53.17 17.24 57.32 14.97 59.59 10.83"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorial);
export default __webpack_public_path__ + "static/media/tutorial.8eb0b52c.svg";
export { ForwardRef as ReactComponent };